import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { Box, Text, Flex, Badge, Divider } from "@mantine/core";

import { SmsApiKeyForm } from "@components/ApiKey";

import {
  ReleaseButton,
  StatusToggle,
  ResendCode,
} from "@components/BulkCommunication/EntitySms";

export default function EntityMessagingService({
  reqData,
  fetchData,
  messagingService,
  ready,
  active,
  setCreatedId,
  allowed,
}) {
  const [tempServiceId, setTempServiceId] = useState(null);
  const [resetting, setResetting] = useState(false);

  const isEffort = reqData?.campaign_effort_id ? true : false;

  // useEffect(() => {
  //   fetchData();
  // }, [tempServiceId]);

  useEffect(() => {
    if (resetting) {
      setTimeout(() => {
        setResetting(false);
      }, 1);
    }
  }, [resetting]);

  if (resetting) return null;

  return (
    <div>
      <Text fw={600} mb="xs">
        Messaging Service
      </Text>
      {messagingService ? (
        <ServiceCard
          info={messagingService}
          ready={ready}
          active={active}
          reqData={reqData}
          fetchData={fetchData}
          allowed={allowed}
        />
      ) : (
        <>
          <SmsApiKeyForm
            reqData={reqData}
            onSuccess={() => {
              fetchData();
              setTempServiceId(null);
              setCreatedId(null);
            }}
            isMessagingService
            onServiceCreate={(e) => {
              setTempServiceId(e);
              setCreatedId(e);
            }}
          />
          {tempServiceId && !isEffort && (
            <Box mt="lg">
              <ReleaseButton
                messagingServiceId={tempServiceId}
                fetchData={() => {
                  setTempServiceId(null);
                  setCreatedId(null);
                  fetchData();
                  setResetting(true);
                }}
                reqData={reqData}
              />
            </Box>
          )}
        </>
      )}
      {messagingService && !isEffort && (
        <Box mt="lg">
          <ReleaseButton
            fetchData={fetchData}
            messagingServiceId={messagingService?.messaging_service_ident}
            reqData={reqData}
          />
        </Box>
      )}
    </div>
  );
}

const ServiceCard = ({ info, ready, active, reqData, fetchData, allowed }) => {
  return (
    <div>
      <Flex mb="xs" align="center" gap="xs">
        <Text size="sm">
          <b>{info.name}</b> (name from provider)
        </Text>
        <Badge size="xs" variant="light">
          {info.use_case}
        </Badge>
      </Flex>
      <Text size="sm">
        <b>Messaging Service Ident</b>: {info.messaging_service_ident}
      </Text>
      {info.short_codes && info.short_codes.length > 0 && (
        <Box mt="sm">
          <Text mb="sm" size="sm" fw={600}>
            Short Codes
          </Text>
          <Box
            mah={250}
            p="xs"
            style={{
              overflowY: "auto",
              backgroundColor: "var(--mantine-color-gray-0)",
              borderRadius: "var(--mantine-radius-md)",
              border: "1px solid var(--mantine-color-gray-2)",
            }}
          >
            {info.short_codes.map((m, i) => (
              <Box mb="xs" key={i}>
                <Flex mb="xs" align="center" gap="xs">
                  <Text fw={600} size="sm">
                    {m.short_code}
                  </Text>
                  <Flex gap="xs" align="center">
                    {m.capabilities.map((capability, ii) => (
                      <Badge key={ii} size="xs" variant="light">
                        {capability}
                      </Badge>
                    ))}
                  </Flex>
                </Flex>
                <Text size="xs">SID: {m.sid}</Text>
                {i < info.short_codes.length - 1 && <Divider mt="md" mb="md" />}
              </Box>
            ))}
          </Box>
        </Box>
      )}
      {info.phones && info.phones.length > 0 && (
        <Box mt="sm">
          <Text mb="sm" size="sm" fw={600}>
            Phones ({info.phones.length})
          </Text>
          <Box
            mah={250}
            p="xs"
            style={{
              overflowY: "auto",
              backgroundColor: "var(--mantine-color-gray-0)",
              borderRadius: "var(--mantine-radius-md)",
              border: "1px solid var(--mantine-color-gray-2)",
            }}
          >
            {info.phones.map((m, i) => (
              <Box key={i}>
                <Flex mb="xs" align="center" gap="xs">
                  <Text fw={600} size="sm">
                    {m.phone_number}
                  </Text>
                  <Flex gap="xs" align="center">
                    {m.capabilities.map((capability, ii) => (
                      <Badge key={ii} size="xs" variant="light">
                        {capability}
                      </Badge>
                    ))}
                  </Flex>
                </Flex>
                <Text size="xs">SID: {m.sid}</Text>
                {i < info.phones.length - 1 && <Divider mt="md" mb="md" />}
              </Box>
            ))}
          </Box>
        </Box>
      )}
      {ready && (
        <Box mt="lg">
          <StatusToggle
            active={active}
            messagingServiceId={info.messaging_service_ident}
            fetchData={fetchData}
            reqData={reqData}
            allowed={allowed}
          />
        </Box>
      )}
      {!ready && (
        <Box mt="xs">
          <ResendCode fetchData={fetchData} info={info} reqData={reqData} />
        </Box>
      )}
    </div>
  );
};
